import { render, staticRenderFns } from "./TransactionsHistoryFilters.vue?vue&type=template&id=0c6e2cb6&scoped=true&"
import script from "./TransactionsHistoryFilters.vue?vue&type=script&lang=js&"
export * from "./TransactionsHistoryFilters.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsHistoryFilters.vue?vue&type=style&index=0&id=0c6e2cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6e2cb6",
  null
  
)

export default component.exports